.marker {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.promo {
  color: var(--purple-8D30F7);
}

.coupon {
  color: var(--blue-1D5AD8);
}
